// Vendor
import * as React from 'react';

// Internal
import { ChartFastFashion } from '@src/charts/ChartFastFashion';
import { Image } from '@src/components/Image';
import { LazyGif } from '@src/components/LazyGif';
import { SlideReveal } from '@src/components/SlideReveal';
import { DEFAULT_SAL_PROPS, SAL_DELAY } from '@src/config/sal';

// Images
import dcAutomationGif from '@src/data/images/dc-automation.gif';
import dcAutomationJpg from '@src/data/images/dc-automation.jpg';

const SecondhandVsFastFashion: React.FC = () => {
  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS} className="max-w-2xl">
        Resale Expected to Be Bigger Than Fast Fashion by 2029
      </h1>
      <p
        {...DEFAULT_SAL_PROPS}
        data-sal-delay={SAL_DELAY * 1}
        className="tup-body chartmax-w-xl"
      >
        Total secondhand market projected to grow to almost twice the size of
        fast fashion by 2029.<sup>1</sup>
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-12">
        <div className="col-span-2">
          <div className="hidden md:block" style={{ height: 480 }}>
            <ChartFastFashion />
          </div>
          <SlideReveal>
            <Image
              alt="Secondhand Vs Fast Fashion Chart"
              addLink={true}
              className="block md:hidden mb-8"
              fileName="1f-chart-mobile.png"
            />
          </SlideReveal>
        </div>
        <div
          {...DEFAULT_SAL_PROPS}
          data-sal="fade"
          data-sal-delay={SAL_DELAY * 2}
          className="bg-gray-0 text-center"
        >
          <h2 className="pl-12 pr-12 pt-4 pb-4">
            thredUP Slows Down the Impact of Fast Fashion
          </h2>
          <LazyGif
            alt="Thredup DC Automation"
            gifSrc={dcAutomationGif}
            placeholderSrc={dcAutomationJpg}
          />
          <p className="pl-12 pr-12 pt-4 pb-4">
            <span className="tup-number font-bold">4 million</span>
            <br />
            fast fashion items have been recirculated by thredUP, saving{' '}
            <b>5.5M lbs</b> of waste.<sup>8</sup>
          </p>
        </div>
      </div>
    </div>
  );
};

export { SecondhandVsFastFashion };
